// **  Initial State
const initialState = {
  userData: {}
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        [action.config.storageTokenKeyName]: action[action.config.storageTokenKeyName]
      }
    case 'USER_PROFILE':
      return {
        ...state,
        userData: action.profile
      }
    case 'LOGOUT':
      const obj = { ...action }
      delete obj.type
      return { ...state, userData: {}, ...obj }
    default:
      return state
  }
}

export default authReducer
